import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { errorMessages } from "./ErrorMessages";

const Fallback = ({ error, resetErrorBoundary }) => {
  const history = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    resetErrorBoundary();
    setIsOpen(false);
    history("/login");
  };

  if (errorMessages[error?.message]) {
    error.message = errorMessages[error.message];
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="error-dialog-title"
      >
        <DialogTitle id="error-dialog-title">
          Oops! Something went wrong!
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1">{error?.message}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Fallback;
